import {
  getLocalCompanyId,
  getLocalJWT,
  login,
  logout,
} from "../components/functions/utilities";
import { User, UserGroup, UserRole, UserStatus } from "../interfaces/interfaces";
import axios from "axios";
import API from "./api";
import { getDeviceId } from "../components/functions/deviceFingerprint";
class UsersRestService {
  getUserListControlPanel = (pageNo, pageCount, search): Promise<any> => {
    return new Promise((resolve, reject) => {
      API.post(`/Users/getUserListControlPanel`, { pageNo, pageCount, search })
        .then((res) => {
          if (res.data.success) {
            console.log(res.data)
            resolve(res.data);
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  getBrandListControlPanel = (pageNo, pageCount, search): Promise<any> => {
    return new Promise((resolve, reject) => {
      API.post(`/Users/getBrandListControlPanel`, { pageNo, pageCount, search })
        .then((res) => {
          if (res.data.success) {
            console.log(res.data)
            resolve(res.data);
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  getUsersByCompany = (): Promise<User[]> => {
    return new Promise((resolve, reject) => {
      API.post(`/Users/GetUsersByCompanyUserPlatform`, {})
        .then((res) => {
          if (res.data.success) {
            resolve(res.data.users);
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  updateUser = (user: User): Promise<User> => {
    return new Promise((resolve, reject) => {
      console.log(user)
      API.post(`/Users/updateUser`, { user })
        .then((res) => {
          if (res.data.success) {
            resolve(res.data.user);
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  newUser = (user: User, reportIds = [], companyIds = []): Promise<User> => {
    user.companyId = Number(getLocalCompanyId());
    user.status = UserStatus.Active;
    return new Promise((resolve, reject) => {
      API.post(`/Users/New`, { user, reportIds, companyIds })
        .then((res) => {
          if (res.data.success) {
            resolve(res.data.user);
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  login = (values): Promise<{ success: boolean; user: User; jwt: string; ip?: string }> => {
    return new Promise((resolve, reject) => {
      API.post(`/Users/Login`, values)
        .then((res) => {
          if (res.data.success) {
            let user: User = res.data.user;
            login(res.data.jwt, user, res.data.isFirstLogin);
            resolve({
              success: res.data.success,
              user: user,
              jwt: res.data.jwt,
              ip: res.data.ip,
            });
          } else reject(res.data.error);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  };

  inviteLogin = (jwtToken): Promise<{ success: boolean; user: User; jwt: string }> => {
    return new Promise((resolve, reject) => {
      API.post(`/Users/inviteLogin`, { jwtToken })
        .then((res) => {
          if (res.data.success) {
            let user: User = res.data.user;
            login(res.data.jwt, user, res.data.isFirstLogin);
            resolve({
              success: res.data.success,
              user: user,
              jwt: res.data.jwt,
            });
          } else reject(res.data.error);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  };

  // Plain axios on purpose: the shared API instance logs the user out and redirects to /login on a 401,
  // which would swallow the "link expired" screen this call exists to drive.
  magicLogin = (
    token: string
  ): Promise<{ success: boolean; user: User; jwt: string; isFirstLogin: boolean; redirectPath: string }> => {
    return axios
      .post(`${import.meta.env.VITE_JIGSAW_DEV_REST_LOCATION}auth/whatsapp/magic/verify`, { token })
      .then((res) => {
        if (!res.data.success) throw new Error("Magic link rejected");
        // Only now drop any previous session, so a dead link never logs out a working one.
        logout();
        login(res.data.jwt, res.data.user, res.data.isFirstLogin);
        return res.data;
      });
  };

  verifyJWT = (): Promise<boolean> => {
    let jwt = getLocalJWT();
    return new Promise((resolve, reject) => {
      getDeviceId().then((deviceId) => {
        API.post(`/Users/VerifyJWT`, { jwt, deviceId })
          .then((res) => {
            if (res.data.success) {
              resolve(res.data.success);
            } else {
              logout();
              resolve(res.data.success);
            }
          })
          .catch(reject);
      });
    });
  };

  updatePassword = (userId: number, password: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      API.post(`/Users/UpdatePassword`, { userId, password })
        .then((res) => {
          if (res.data.success) {
            resolve();
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  deleteUser = (userId: number): Promise<void> => {
    return new Promise((resolve, reject) => {
      API.post(`/Users/Delete`, { userId })
        .then((res) => {
          if (res.data.success) {
            resolve();
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  changeUserRole = (role, userId: number): Promise<void> => {
    return new Promise((resolve, reject) => {
      API.post(`/Users/changeUserRole`, { role, userId })
        .then((res) => {
          if (res.data.success) {
            resolve();
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  getUserGroupListControlPanel = (pageNo, pageCount, search): Promise<any> => {
    return new Promise((resolve, reject) => {
      API.post(`/UserGroups/getUserGroupListControlPanel`, {
        pageNo,
        pageCount,
        search,
      })
        .then((res) => {
          if (res.data.success) {
            resolve(res.data);
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  addMemberInGroup = (userIds, removedUser, groupId): Promise<any> => {
    return new Promise((resolve, reject) => {
      API.post(`/UserGroups/addMemberInGroup`, {
        userIds,
        removedUser,
        groupId,
      })
        .then((res) => {
          resolve(res.data?.groupMember);
        })
        .catch(reject);
    });
  };
  getAllUserGroups = (): Promise<UserGroup[]> => {
    return new Promise((resolve, reject) => {
      API.post(`/UserGroups/GetAllGroups`, {})
        .then((res) => {
          if (res.data.success) {
            resolve(res.data.userGroups);
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  newUserGroup = (userGroup: UserGroup): Promise<UserGroup> => {
    return new Promise((resolve, reject) => {
      API.post(`/UserGroups/NewGroup`, { userGroup })
        .then((res) => {
          if (res.data.success) {
            resolve(res.data.userGroup);
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  updateUserGroup = (userGroup: UserGroup): Promise<void> => {
    return new Promise((resolve, reject) => {
      API.post(`/UserGroups/Update`, { userGroup })
        .then((res) => {
          if (res.data.success) {
            resolve();
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  deleteUserGroup = (userGroupId: number): Promise<void> => {
    return new Promise((resolve, reject) => {
      API.post(`/UserGroups/Delete`, { userGroupId })
        .then((res) => {
          if (res.data.success) {
            resolve();
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  deleteUserFromGroup = (id: number): Promise<void> => {
    return new Promise((resolve, reject) => {
      API.post(`/UserGroups/deleteUserFromGroup`, { id })
        .then((res) => {
          if (res.data.success) {
            resolve();
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  renameGroup = (id: number, name: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      API.post(`/UserGroups/Update`, { id, name })
        .then((res) => {
          if (res.data.success) {
            resolve();
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  CreateGroupWithMember = (groupName: string, userIds): Promise<void> => {
    return new Promise((resolve, reject) => {
      API.post(`/UserGroups/CreateGroupWithMember`, {
        groupName,
        userIds,
      })
        .then((res) => {
          if (res.data.success) {
            resolve();
          } else reject(res.data.error);
        })
        .catch(reject);
    });
  };

  verifyUserEmail = (user: User): Promise<any> => {
    return new Promise((resolve, reject) => {
      API.post(`/users/newuser/verify`, { user })
        .then(res => {
          console.log(res)
          resolve('')
        })
        .catch(err => {
          reject(err.response.data.errors[0])
        })
    })
  }

  verifyAgencyDetails = (user: User): Promise<any> => {
    return new Promise((resolve, reject) => {
      API.post(`/invites/agency/verify`, { user })
        .then(res => {
          console.log(res)
          resolve('')
        })
        .catch(err => {
          reject(err.response.data.errors[0])
        })
    })
  }
}

export let UsersRestS = new UsersRestService();
